// src/pages/Letters.jsx
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import LetterForm from '../components/LetterForm';
import './Letters.css';
import '../styles/common.css';

function Letters() {
  const { t } = useTranslation();
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [replyTargetId, setReplyTargetId] = useState(null);
  const [replyMessage, setReplyMessage] = useState('');
  const [replyName, setReplyName] = useState('');

  useEffect(() => {
    fetchLetters();
  }, []);

  const fetchLetters = async () => {
    const { data, error } = await supabase
      .from('letters')
      .select('id, name, message, created_at, parent_id, is_private')
      .order('created_at', { ascending: false });

    if (!error) {
      setLetters(data);
    }
    setLoading(false);
  };

  const handleReplySubmit = async (e, parentId) => {
    e.preventDefault();
    if (!replyMessage.trim()) return;

    const { error } = await supabase.from('letters').insert([
      {
        name: replyName || '익명',
        message: replyMessage,
        parent_id: parentId,
      },
    ]);

    if (!error) {
      setReplyMessage('');
      setReplyName('');
      setReplyTargetId(null);
      fetchLetters();
    }
  };

  const renderReplies = (parentId) => {
    return letters
      .filter((reply) => reply.parent_id === parentId)
      .map((reply) => (
        <div key={reply.id} className="reply">
          ↳ <strong>{reply.name}</strong>: {reply.message}
        </div>
      ));
  };

  return (
    <div className="letters-page">
      <h2 className="section-title">방명록</h2>

      <LetterForm onSubmitSuccess={fetchLetters} />

      {loading ? (
        <p>로딩 중...</p>
      ) : (
        letters
          .filter((letter) => letter.parent_id === null)
          .map((letter) => (
            <div key={letter.id} className="letter-card">
              <div className="letter-header">
                <span className="letter-name">{letter.name}</span>
                <span className="letter-date">
                  {new Date(letter.created_at).toLocaleDateString('ko-KR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </span>
              </div>
              <div className="letter-message">{letter.is_private ? t('letters.private') : letter.message}</div>

              {replyTargetId === letter.id ? (
                <form className="reply-form" onSubmit={(e) => handleReplySubmit(e, letter.id)}>
                  <input
                    type="text"
                    placeholder="이름 (선택)"
                    value={replyName}
                    onChange={(e) => setReplyName(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="답글을 입력하세요"
                    value={replyMessage}
                    onChange={(e) => setReplyMessage(e.target.value)}
                    required
                  />
                  <div className="reply-buttons">
                    <button type="submit">등록</button>
                    <button type="button" onClick={() => setReplyTargetId(null)}>
                      취소
                    </button>
                  </div>
                </form>
              ) : (
                <>
                  {renderReplies(letter.id)}
                  <span className="reply-link" onClick={() => setReplyTargetId(letter.id)}>
                    답글
                  </span>
                </>
              )}
            </div>
          ))
      )}
    </div>
  );
}

export default Letters;
